import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Carousel, Image } from "antd";
import { useRef, useState } from "react";
import "./SliderCarousel.less";

const SliderCarousel = ({ imageGallery }) => {
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleBeforeChange = (_, next) => {
    setCurrentIndex(next);
  };
  return (
    <div className="carouselWrapper">
      <Carousel
        ref={carouselRef}
        className="customCarousel"
        effect="scrollx"
        dots={false}
        infinite
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        beforeChange={handleBeforeChange}
      >
        {imageGallery.map((img, i) => {
          const total = imageGallery.length;
          const isCenter = i === currentIndex;
          const isLeft = i === (currentIndex - 1 + total) % total;
          const isRight = i === (currentIndex + 1) % total;

          return (
            <div
              key={i}
              className={`carouselItem ${isCenter ? "is-center" : ""} ${
                isLeft ? "is-left" : ""
              } ${isRight ? "is-right" : ""}`}
            >
              <div className="carouselImageContainer">
                <Image
                  className="carouselImage"
                  src={img}
                  alt={`Image ${i + 1}`}
                  preview={isCenter}
                />
              </div>
            </div>
          );
        })}
      </Carousel>
      {imageGallery.length > 1 && (
        <>
          <button
            className="arrowLeft"
            onClick={() => carouselRef.current?.prev()}
            aria-label="Previous image"
          >
            <LeftOutlined color="#fff" />
          </button>
          <button
            className="arrowRight"
            onClick={() => carouselRef.current?.next()}
            aria-label="Next image"
          >
            <RightOutlined color="#fff" />
          </button>
        </>
      )}
    </div>
  );
};

export default SliderCarousel;
